import { makeMapStateToProps, StateProps, ContainerProps } from "./map-to-props-factory";
import { createUniversalConnector } from "../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";
import { ComponentProps } from "./props";

export default withSportsbookBetslipContext(({ localization, preferences }: SportsbookBetslipContext) => ({
  localization,
  preferences,
}))(createUniversalConnector<StateProps, {}, ContainerProps, ComponentProps>(makeMapStateToProps, {}));
